// extracted by mini-css-extract-plugin
export default {"unitSelectFirst":"index_unitSelectFirst__sIzXE"};